
import { ISDKInfo } from '@kentico/kontent-core';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '2.9.2',
    name: '@kentico/kontent-management'
};
